import { TRAINING_STATUS, EDR_AGENT_STATUS } from '@/lib/constants/employees'
import { SIGNED_STATUS } from '@/lib/constants/policies'
import { EMPLOYEE_IDENTITY_STATES } from '@/lib/constants/identities'
export const EMPLOYEE_TABLE = {
  TITLE: 'Lista de empleados',
  PAGE_TITLE: 'Dashboard de Empleados',
  ADD_EMPLOYEE: 'Agregar Empleado',
  EXPORT_SIGNATURES: 'Exportar firmas',
  EXPORT_SIGNATURES_EMPTY: 'Todavía no hay firmas de políticas que exportar.',
  EXPORT_EMPLOYEES: 'Exportar empleados',
  EXPORT_EMPLOYEES_EMPTY: 'No hay empleados que exportar.',
  SEARCH_PLACEHOLDER: 'Buscar empleados...',
  TABLE_HEADER: {
    NAME: 'Nombre',
    EMAIL: 'Correo electrónico',
    POLICIES_SIGNED: 'Políticas',
    TRAINING_COMPLETED: 'Formación',
    ROLE: 'Rol',
    DEPARTMENT: 'Departamento',
    IDENTITIES: 'Identidades',
    EDR_AGENT: 'Agente EDR',
    SAAS_ACCESS: 'SaaS',
    SSO: 'SSO',
  },
  FILTER_BY_ROLE: 'Filtrar por rol',
  FILTER_BY_POLICY_STATUS: 'Filtrar por estado de políticas',
  FILTER_BY_TRAINING_STATUS: 'Filtrar por estado de formación',
  FILTER_BY_IDENTITIES: 'Filtrar por identidades',
  FILTER_BY_EDR_AGENT: 'Filtrar por estado del agente EDR',
  FILTER_BY_SAAS: 'Filtrar por SaaS',
  IDENTITY_STATUS: {
    all: 'Todas',
    [EMPLOYEE_IDENTITY_STATES.ACTIVE]: 'Activa',
    [EMPLOYEE_IDENTITY_STATES.REMOVED]: 'Eliminada',
    [EMPLOYEE_IDENTITY_STATES.NONE]: 'Sin identidad',
    service: 'Servicio',
  },
}
export const EMPLOYEE_CREATION_DIALOG = {
  TITLE: 'Nuevo Empleado',
  NAME: 'Nombre',
  EMAIL: 'Correo electrónico',
  BULK_UPLOAD: 'Carga masiva',
  CREATE: 'Crear',
  CANCEL: 'Cancelar',
  BULK_UPLOAD_TEMPLATE: 'Plantilla de carga masiva',
  SUCCESS_MESSAGE: (name: string) => `Empleado "${name}" creado correctamente`,
  BULK_UPLOAD_SUCCESS_MESSAGE: 'Empleados creados correctamente',
  ERROR_MESSAGE: 'Por favor, rellene todos los campos',
  TRAINING_STATUS: 'Estado de la formación',
  ROLE: 'Rol',
}
export const EMPLOYEE_BULK_UPLOAD_DIALOG = {
  TITLE: 'Carga Masiva de Empleados',
  DESCRIPTION: 'Sube un archivo CSV o Excel para crear múltiples empleados a la vez.',
  UPLOAD_FILE: 'Subir Archivo',
  UPLOADING: 'Subiendo...',
  TEMPLATE: 'Plantilla',
  CREATING_USERS: 'Creando empleados en masa...',
  SUCCESS: 'Empleados creados correctamente',
  CANCEL: 'Cancelar',
}
export const SIGNED_POLICIES = {
  [SIGNED_STATUS.SIGNED]: 'Firmado',
  [SIGNED_STATUS.NOT_SIGNED]: 'No firmado',
  [SIGNED_STATUS.PARTIALLY_SIGNED]: 'Parcialmente firmado',
}
export const TRAINING_STATUS_TEXTS = {
  [TRAINING_STATUS.COMPLETED]: 'Completada',
  [TRAINING_STATUS.NOT_COMPLETED]: 'Pendiente',
  [TRAINING_STATUS.PARTIALLY_COMPLETED]: 'En Progreso',
  [TRAINING_STATUS.UNKNOWN]: 'Desconocido',
}
export const EDR_AGENT_STATUS_TEXTS = {
  [EDR_AGENT_STATUS.INSTALLED]: 'Instalado',
  [EDR_AGENT_STATUS.NOT_INSTALLED]: 'No instalado',
}
export const EMPLOYEE_BULK_ACTIONS = {
  SELECTED_SINGULAR: 'usuario seleccionado',
  SELECTED_PLURAL: 'usuarios seleccionados',
  CLEAR: 'Limpiar',
  DELETE_SELECTED: 'Eliminar seleccionados',
  CONFIRM_DELETE_TITLE: 'Eliminar usuarios',
  CONFIRM_DELETE_DESCRIPTION: (count: number) =>
    `¿Estás seguro de que deseas eliminar ${count} usuario(s)? Esta acción no se puede deshacer.`,
}
export const EMPLOYEE_DRAWER = {
  TAB_GENERAL: 'General',
  TAB_SAAS: (count: number) => `SaaS (${count})`,
  TAB_LIFECYCLE: 'Onboarding / Offboarding',
  PROFILE: 'Perfil',
  COMPLIANCE: 'Cumplimiento',
  EMPLOYEE_DETAILS: 'Detalles del Empleado',
  INFORMATION: 'Información',
  ATTRIBUTES: 'Atributos',
  NAME: 'Nombre',
  EMAIL: 'Correo Electrónico',
  ROLE: 'Rol',
  DEPARTMENTS: 'Departamentos',
  SSO: 'SSO',
  IDENTITY_SOURCES: 'Fuentes de Identidad',
  IDENTITIES: 'Identidades',
  TRAINING_STATUS: 'Estado de Formación',
  POLICIES_SIGNED: 'Políticas Firmadas',
  SIGN_ALL: 'Firmar todas',
  CLEAR_ALL: 'Borrar todas',
  SIGNATURE_ACTIONS: 'Acciones de firmas',
  CLEAR_ALL_SIGNATURES: 'Eliminar todas las firmas',
  CLEAR_ALL_SIGNATURES_TITLE: '¿Eliminar todas las firmas?',
  CLEAR_ALL_SIGNATURES_DESCRIPTION: (name: string) =>
    `Esto elimina cada firma de política registrada para ${name}. Esta acción no se puede deshacer.`,
  SIGNATURES_CLEARED: (count: number) => `${count} firma${count === 1 ? '' : 's'} eliminada${count === 1 ? '' : 's'}.`,
  NO_POLICIES_TO_SIGN: 'Esta organización todavía no tiene políticas disponibles para firmar.',
  POLICY_SIGNATURES: 'Firmas de políticas',
  POLICY_SIGNATURES_EMPTY: 'Sin políticas listadas',
  POLICY_SIGNATURES_ERROR: 'Error al cargar las políticas',
  POLICY_SIGNATURES_LATEST: (versionNumber: number) => `última v${versionNumber}`,
  EDR_AGENT: 'Agente EDR',
  IDENTITY_ACTIVE: 'La identidad está activa',
  IDENTITY_INACTIVE: 'La identidad está inactiva',
  DELETE_USER: 'Eliminar usuario',
  CONFIRM_DELETE_USER: '¿Estás seguro de que deseas eliminar este usuario? Esta acción no se puede deshacer.',
  USER_DELETED: 'Usuario eliminado correctamente',
  ROLE_UPDATED: 'Rol actualizado correctamente',
  SAAS_ACCESS: 'Gestión de SaaS',
  HIDE_INTERNAL_APPS: 'Ocultar apps internas',
  INTERNAL_APP: 'Interna',
  ACCESS_GRANTED: 'Acceso concedido',
  SOURCE: 'Fuente',
  NOT_AVAILABLE: 'N/D',
  NOT_ASSIGNED_TO_DEPARTMENTS: 'No asignado a departamentos del usuario',
  SOURCE_TOOLTIP: (source: string) => `Fuente: ${source}`,
  ACCESS_GRANTED_ON: (date: string) => `Acceso concedido el ${date}`,
  TWO_FA_SHORT: '2FA',
  TWO_FA_ENABLED_ON: (source: string) => `2FA activado vía ${source} para este SaaS`,
  TWO_FA_DISABLED_ON: (source: string) => `2FA desactivado en ${source} para este SaaS`,
  TWO_FA_UNKNOWN_FOR: (source: string) => `Estado de 2FA desconocido en ${source} para este SaaS`,
  TWO_FA_UNKNOWN: 'Estado de 2FA desconocido',
}

export const DEPARTMENT_SELECTOR = {
  SELECT_DEPARTMENTS: 'Seleccionar departamentos',
  ADD_MORE: 'Añadir departamento',
  SEARCH: 'Buscar departamentos...',
  LOADING: 'Cargando...',
  NO_DEPARTMENTS_FOUND: 'No se encontraron departamentos.',
}
export const ONBOARDING_SECTION = {
  TITLE: 'Onboarding',
  START_ONBOARDING: 'Iniciar Onboarding',
  STARTING: 'Iniciando...',
  EMPTY_MESSAGE: 'Empleado sin Onboarding.',
}
export const OFFBOARDING_SECTION = {
  TITLE: 'Offboarding',
  START_OFFBOARDING: 'Iniciar Offboarding',
  STARTING: 'Iniciando...',
  EMPTY_MESSAGE: 'Empleado sin Offboarding.',
}
export const CHECKLIST_EDIT = {
  EDIT: 'Editar',
  DONE: 'Listo',
  ADD_TASK: 'Añadir tarea',
  SAVE: 'Guardar',
  CANCEL: 'Cancelar',
  REMOVE: 'Eliminar',
  RESET_TO_DEFAULTS: 'Restablecer valores predeterminados',
  RESET_CONFIRM_TITLE: '¿Restablecer la lista?',
  RESET_CONFIRM_BODY:
    'Esto reemplazará la lista completa con los elementos predeterminados. Las personalizaciones se perderán. Los empleados en curso recibirán una copia nueva. No se puede deshacer.',
  EDIT_BANNER_TITLE: 'Estás editando la plantilla de la organización',
  EDIT_BANNER_BODY: 'Los cambios se aplican a todos los empleados actuales y futuros de esta organización.',
  RENAME_PLACEHOLDER: 'Nombre de la tarea',
  REMOVE_CONFIRM_TITLE: '¿Eliminar este elemento?',
  REMOVE_CONFIRM_BODY:
    'Se eliminará de esta lista y de la lista de cada empleado, incluidas las instancias completadas. No se puede deshacer.',
  CONTROL_NONE: 'Sin control',
  CONTROL_SEARCH_PLACEHOLDER: 'Buscar controles...',
  CONTROL_LABEL: 'Control vinculado',
  EDIT_TOOLTIP: 'Editar plantilla de la lista',
  DRAG_HANDLE_LABEL: 'Arrastrar para reordenar',
  REMOVE_BUTTON_LABEL: 'Eliminar elemento',
  MENU_LABEL: 'Acciones de la lista',
}
